module.exports = __webpack_public_path__ + "76c40de10e16d87d16c046a952446043.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/banner/qq-browser.png
// module id = 659
// module chunks = 0